import css from 'styled-jsx/css';
import { colors, icons, typography } from '../../../../../config/styles';
import { svgToDataUri } from '../../../../../utils/styles/svgMixins';

const ProductSpecificationsDesktopStyle = css`
  .product-specifications {
    display: flex;
    flex-direction: row;
    gap: 24px;
    &-column {
      width: 100%;
      height: auto;

      span {
        font-size: 14px;
        b {
          font-weight: bold;
          margin-left: 2px;
        }
      }
    }
    .fa--product-specifications-column__desktop {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
  }

  /* Element: Specifications container */
  .product-specifications :global(.mkp-color-swatch) {
    margin-bottom: 0 !important;
  }

  .product-specifications :global(.colorSwatches-container) {
    margin-top: 0px;
  }

  .product-specifications :global(.operator-container) {
    margin-bottom: 0px;
  }

  .product-specifications :global(.color-swatch-container) {
    /* Removed max-height to allow natural expansion */
  }

  .additional-pdp-label-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* Element: Softline CMR Wrapper*/
  .product-specifications :global(.softline-cmr-wrapper) {
    margin: 0;
  }

  .product-specifications :global(.priceTag) {
    width: 100% !important;
  }

  .prices-container {
    width: 100%;

    & > div {
      flex: 1 0 50%;
    }
  }

  .cmr-points {
    font-size: ${typography.xs2};
    margin-top: 11px;
    color: ${colors.black.shade7};
  }

  .boomIcon {
    background-image: url('${svgToDataUri(icons.boomIcon)}');
    background-repeat: no-repeat;
    width: 60px;
    height: 13px;
    margin: 10px 0;
    display: block;
  }

  .size-container {
    padding: 0;
  }

  .addToCart-container {
    margin-bottom: 30px;
    :global(.csicon-arrow_down_small, .csicon-arrow_right) {
      margin-left: 9px;
      font-size: ${typography.xs2};
    }
    &.rebranded {
      max-width: 300px;
      margin-bottom: 24px;
    }
  }
  .mkp-softline-size {
    padding-top: 0;
  }
  .specifications-divider {
    border-bottom: 1px solid ${colors.gray.shade3};
  }
  .multipurpose-badge {
    width: 100%;
    margin-bottom: 24px;
  }
  .meatstickers-container {
    margin-bottom: 16px;
  }
  .delivery-options-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
  }
  .dlv-opt-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    width: 100%;
  }
  .whitelabel {
    border: none;
    box-shadow: none;
  }
  .variant-id-seller {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    width: 100%;
  }
  .variant-id-seller :global(.variant-id) {
    font-size: 12px;
  }
`;

export { ProductSpecificationsDesktopStyle };
